"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightCompanyEdit = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../../hooks/useForm");
const classFunctions_1 = require("../../../../utils/classFunctions");
const locale_1 = require("../../../../utils/locale");
const Button_1 = require("../../../Button");
const CheckBox_1 = require("../../../CheckBox");
const Field_1 = require("../../../Form/Field");
const Multilanguage_1 = require("../../../Form/Field/Multilanguage");
const Select_1 = require("../../../Form/Field/Select");
const Textarea_1 = require("../../../Form/Field/Textarea");
const Section_1 = require("../../../Page/Title/Section");
const Sub_1 = require("../../../Page/Title/Sub");
const Separator_1 = require("../../../Separator");
const Tabs_1 = require("../../../Tabs");
const items_1 = require("./items");
require("./index.scss");
const className = 'company-edit';
const schema = (0, useForm_1.createSchema)(x => x.object({
    shape: {
        name: x.string(),
        code: x.string({
            minLength: 2,
        }),
        isActive: x.boolean(),
        email: x.string({
            optional: true,
            email: true,
        }),
        pnlExportType: x.string(),
        pnlUploadUrl: x.string({
            optional: true,
            url: true,
        }),
        checkInType: x.string(),
        checkInUrl: x.string({
            optional: true,
            url: true,
        }),
        checkInParameters: x.string({
            optional: true,
        }),
        baggage: x.object({
            shape: {
                weight: x.number(),
                infantWeight: x.number(),
                description: x.object({
                    shape: locale_1.allLocales.reduce((acc, locale) => ({
                        ...acc,
                        [locale]: x.string({
                            optional: true,
                        }),
                    }), {}),
                    optional: true,
                }),
            },
        }),
    },
}));
const FlightCompanyEdit = (props) => {
    const { propsValues, onSubmit, modificators } = props;
    const [activeLocale, setActiveLocale] = (0, react_1.useState)('en');
    const { field, fieldControlled, getError, createSubmit, } = (0, useForm_1.useAdvancedForm)({
        schema,
        defaultValues: propsValues !== null && propsValues !== void 0 ? propsValues : {
            checkInType: 'disabled',
            isActive: true,
            pnlExportType: 'standard',
            baggage: {
                weight: 0,
                infantWeight: 0,
            },
        },
    });
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'airplane', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:AirlineCompany', defaultMessage: 'Airline company' }) }),
            react_1.default.createElement("div", { className: `${className}__general` },
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('name', { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:Name', defaultMessage: 'Name' }) })),
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('code', { dataType: 'string', upperCase: true }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:Code', defaultMessage: 'Code' }) }))),
                react_1.default.createElement("div", { className: `${className}__checkbox` },
                    react_1.default.createElement(CheckBox_1.CheckBox, { ...field('isActive', { dataType: 'boolean' }), text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:Active', defaultMessage: 'Active' }) }))),
            react_1.default.createElement(Separator_1.Separator, { horizontal: true }),
            react_1.default.createElement("div", { className: `${className}__pnl` },
                react_1.default.createElement(Section_1.PageSectionTitle, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:PNLData', defaultMessage: 'PNL Data' }) }),
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('email', { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:pnlEMail', defaultMessage: 'Email Address' }), info: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:pnlEMailInfo', defaultMessage: "If an email address is specified then it's used to send the PNL data to this airline company." }) })),
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Select_1.FormFieldSelect, { ...fieldControlled('pnlExportType'), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:PnlExportType', defaultMessage: 'Export Type' }), items: items_1.pnlExportTypes, toItem: (value) => ({
                                label: items_1.pnlExportTypeMap[value],
                                value,
                            }) }))),
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('pnlUploadUrl', { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:UploadURL', defaultMessage: 'Upload URL' }), info: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:pnlUploadUrllInfo', defaultMessage: "If a URL with FTP/SFTP/FTPS protocol is specified then it's used for uploading PNL data for this company. Format: protocol://user:pwd@hostname.com/path." }) })))),
            react_1.default.createElement(Separator_1.Separator, { horizontal: true }),
            react_1.default.createElement("div", { className: `${className}__checkin` },
                react_1.default.createElement(Section_1.PageSectionTitle, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:OnlineCheckin', defaultMessage: 'Online checkin' }) }),
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Select_1.FormFieldSelect, { ...fieldControlled('checkInType'), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:checkInType', defaultMessage: 'Checkin Type' }), items: items_1.checkInTypes, toItem: (value) => ({
                                label: items_1.checkInTypeMap[value],
                                value,
                            }) })),
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('checkInUrl', { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:CheckinURL', defaultMessage: 'Checkin URL' }) }))),
                react_1.default.createElement("div", { className: `${className}__field ${className}__field--full` },
                    react_1.default.createElement(Textarea_1.FormFieldTextarea, { ...field('checkInParameters', { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:CheckinParams', defaultMessage: 'Checkin Parameters' }), info: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:CheckinParamsInfo', defaultMessage: 'Please use the following placeholders for the parameters: [passenger_firstname] [passenger_lastname] [flightnumber] [flightdate]' }) }))),
            react_1.default.createElement(Separator_1.Separator, { horizontal: true }),
            react_1.default.createElement("div", { className: `${className}__baggage` },
                react_1.default.createElement(Section_1.PageSectionTitle, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:Baggage', defaultMessage: 'Baggage' }) }),
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('baggage.weight', { dataType: 'number' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:Baggage', defaultMessage: 'Baggage' }), addon: 'kg' }))),
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('baggage.infantWeight', { dataType: 'number' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:InfantBaggage', defaultMessage: 'Infant Baggage' }), addon: 'kg' }))),
                react_1.default.createElement("div", { className: `${className}__field ${className}__field--full` },
                    react_1.default.createElement(Tabs_1.Tabs, { tabs: locale_1.allLocales.map(locale => ({
                            id: locale,
                            title: Multilanguage_1.localeLabels[locale],
                            content: (react_1.default.createElement(Textarea_1.FormFieldTextarea, { ...field(`baggage.description.${locale}`, { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:BaggageDescription', defaultMessage: 'Baggage description' }), modificators: 'top-padding' })),
                            hasError: !!getError(`baggage.description.${locale}`),
                        })), selectedId: activeLocale, select: setActiveLocale, modificators: 'languages' }))),
            react_1.default.createElement("div", { className: `${className}__button` },
                react_1.default.createElement(Button_1.Button, { icon: 'save', type: 'submit', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:Save', defaultMessage: 'Save' }), onClick: createSubmit(onSubmit) })))));
};
exports.FlightCompanyEdit = FlightCompanyEdit;
//# sourceMappingURL=index.js.map